import { render, staticRenderFns } from "./UpdateShopTimings.vue?vue&type=template&id=1f18bb74&"
import script from "./UpdateShopTimings.vue?vue&type=script&lang=js&"
export * from "./UpdateShopTimings.vue?vue&type=script&lang=js&"
import style0 from "./UpdateShopTimings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports